(function () {
  'use strict';

  const BADGE_ID = 'a97-gpo-badge';
  const STYLE_ID = 'a97-price-style';
  const POINTS_ID = 'a97-gpo-points';
  const DISCOUNT_ID = 'a97-discount-pct';

  // easyPoints 付与/利用 対象外フラグ（Liquid埋め込み #a97-point-exclusion を同期読み）
  var _pointExclusion = null;
  function getPointExclusion() {
    if (_pointExclusion) return _pointExclusion;
    var el = document.getElementById('a97-point-exclusion');
    if (el) {
      try { _pointExclusion = JSON.parse(el.textContent); return _pointExclusion; } catch (e) {}
    }
    _pointExclusion = { noEarn: false, noDiscount: false };
    return _pointExclusion;
  }

  // 付与レートとキャンペーン判定（EasyPoints）。
  // 一次情報はアプリが全ページに埋める #easy-points-widget-settings（同期で読める・通信なし）。
  // 無いときだけ App Proxy の order_point_rule を取る（未ログインでもショップ既定が返る）。
  // 経緯・実測: claude/商品ページのポイント表示_付与レート連動_2026-10-22.md
  var RATE_KEY = 'a97-point-rate';
  var RATE_TTL = 600000;
  var RATE_FALLBACK = { cv: 100, pv: 1, campaign: false, base: null };
  var _rate = null;          // { cv: 円, pv: ポイント, campaign: bool, base: {cv,pv}|null }
  var _rateLoading = false;
  var _rateFailed = false;
  var _ptsArgs = null;       // レート到着後に描き直すための直近の引数

  function num(n) { return Number(n || 0).toLocaleString('ja-JP'); }

  function embeddedRate() {
    try {
      var el = document.getElementById('easy-points-widget-settings');
      if (!el) return null;
      var d = JSON.parse(el.textContent).data || {};
      var a = d.shop && d.shop.loyalty && d.shop.loyalty.easy_points_attributes;
      if (!a || !a.currency_value || !a.point_value) return null;
      var tr = a.tier_rules || {};
      var keys = Object.keys(tr);
      // 顧客のティアが分かればそのティア、分からなければ最初のティアを「通常レート」とする
      var tierName = d.customer && d.customer.tier;
      var uid = keys.filter(function (k) { return tr[k] && tr[k].name === tierName; })[0] || keys[0];
      var t = uid ? tr[uid] : null;
      var cur = (a.point_rules && uid && a.point_rules[uid]) || a;
      var base = (t && t.currency_value && t.point_value) ? { cv: Number(t.currency_value), pv: Number(t.point_value) } : null;
      var r = { cv: Number(cur.currency_value), pv: Number(cur.point_value), base: base };
      r.campaign = base ? (r.pv / r.cv > base.pv / base.cv) : !!a.point_campaign;
      return r;
    } catch (e) { return null; }
  }

  function readRate() {
    // 埋め込み JSON はアプリが </body> 直前に出すので、先頭で走る初回はまだ無い。
    // App Proxy の値で先に描いたあとも、埋め込みが現れたらそちらに乗り換える（通常ティアのレートは埋め込みにしか無い）
    if (_rate && _rate.embed) return _rate;
    var e = embeddedRate();
    if (e) { e.embed = true; _rate = e; return _rate; }
    if (_rate) return _rate;
    try {
      var o = JSON.parse(sessionStorage.getItem(RATE_KEY) || 'null');
      if (o && o.r && Date.now() - o.t < RATE_TTL) { _rate = o.r; _rate.embed = false; return _rate; }
    } catch (err) {}
    return null;
  }

  function loadRate() {
    if (_rate || _rateLoading) return;
    _rateLoading = true;
    // Accept: application/json を付けると App Proxy が 406 を返す
    fetch('/apps/loyalty/order_point_rule', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (j) {
        if (!j || !j.currency_value || !j.point_value) return Promise.reject();
        var tiers = j.tier_maintenance_data && j.tier_maintenance_data.advancement_data &&
                    j.tier_maintenance_data.advancement_data.tiers;
        var t = tiers && tiers.filter(function (x) { return x.uid === j.tier_uid; })[0] || (tiers && tiers[0]);
        var base = (t && t.ratio) ? { cv: 100, pv: Math.round(t.ratio * 100 * 1000) / 1000 } : null;
        _rate = { cv: Number(j.currency_value), pv: Number(j.point_value), base: base, embed: false };
        // 未ログインの応答にはティア情報が無く通常レートが分からない。その場合はアプリのフラグで判定する
        _rate.campaign = base ? (_rate.pv / _rate.cv > base.pv / base.cv) : !!j.point_campaign;
        try { sessionStorage.setItem(RATE_KEY, JSON.stringify({ t: Date.now(), r: _rate })); } catch (e) {}
      })
      .catch(function () { _rateFailed = true; })
      .then(function () {
        _rateLoading = false;
        if (!_ptsArgs) return;
        // Fabric が価格ブロックを差し替えていることがあるので、生きているコンテナに描く
        var c = document.contains(_ptsArgs[0]) ? _ptsArgs[0] : document.querySelector('.text-block [ref="priceContainer"]');
        if (c) showPoints(c, _ptsArgs[1], _ptsArgs[2]);
      });
  }

  /**
   * 還元率の表記（「5%」「1.5%」）。倍率（「5倍」）は使わない。
   * ポイントは金額にレートを掛けてから丸めるので、商品ごとのポイント数は通常の整数倍にならない。
   * 「5倍」と書くと実際より有利に読める余地がある（景表法の有利誤認の観点）。還元率なら数字がそのまま合う。
   */
  function pctLabel(r) {
    var v = Math.round(r.pv / r.cv * 1000) / 10;
    return (v % 1 === 0 ? String(v) : v.toFixed(1)) + '%';
  }

  /**
   * キャンペーン終了日（theme.liquid が window.A97_POINTS.campaignEnd に 'YYYY-MM-DD' で入れる）。
   * 今日以降のときだけ「10/31(土) まで」を返す。過ぎていれば空。
   * キャンペーン中かどうかはこの値では決めない（アプリの設定で決まる）ので、消し忘れても表示は壊れない。
   */
  function untilText() {
    var g = window.A97_POINTS;
    var v = g && g.campaignEnd;
    if (!v || !/^\d{4}-\d{2}-\d{2}$/.test(v)) return '';
    var p = v.split('-');
    var d = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]), 23, 59, 59);
    if (isNaN(d) || d < new Date()) return '';
    return (d.getMonth() + 1) + '/' + d.getDate() + '(' + '日月火水木金土'[d.getDay()] + ') まで';
  }

  var CAT_TAG_MAP = {
    'cat:aeg': '電動ガン',
    'cat:gas': 'ガスガン',
    'cat:co2': 'CO2ガスガン',
    'cat:ext': '外装パーツ',
    'cat:int': '内部パーツ',
    'cat:opt': '光学機器',
    'cat:mag': 'マガジン',
    'cat:bat': 'バッテリー類',
    'cat:amm': '消耗品',
    'cat:gea': '装備品',
    'cat:too': '工具',
    'cat:ctm': 'カスタムメニュー'
  };

  var CAT_COLLECTION_MAP = {
    'cat:aeg': 'cat-aeg',
    'cat:gas': 'cat-gas',
    'cat:co2': 'cat-co2',
    'cat:ext': 'cat-ext',
    'cat:int': 'cat-int',
    'cat:opt': 'cat-opt',
    'cat:mag': 'cat-mag',
    'cat:bat': 'cat-bat',
    'cat:amm': 'cat-amm',
    'cat:gea': 'cat-gea',
    'cat:too': 'cat-too',
    'cat:ctm': 'cat-ctm'
  };

  function breakLongBracket(html) {
    var m = html.match(/^(【[^】]+】)/);
    if (m && m[1].length > 8) {
      return html.replace(/^(【[^】]+】)/, '$1<br>');
    }
    return html;
  }

  var VENDOR_LABEL = 'メーカー';   // ベンダーピル内の小見出し（文言変更はここ）

  function normalizeSpace(s) {
    return (s || '').replace(/\s+/g, ' ').trim();
  }

  // 商品名コピー用: Clipboard API → execCommand フォールバック
  function copyTextToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:fixed;top:-1000px;left:-1000px;opacity:0;';
        document.body.appendChild(ta);
        ta.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        if (ok) resolve(); else reject(new Error('execCommand failed'));
      } catch (e) { reject(e); }
    });
  }

  var ICON_COPY =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<rect x="9" y="9" width="12" height="12" rx="2"/>' +
    '<path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1"/></svg>';

  var ICON_DONE =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M20 6 9 17l-5-5"/></svg>';

  function setCopyButtonState(btn, icon, label) {
    btn.innerHTML = icon + '<span class="a97-copy-title__label"></span>';
    btn.querySelector('.a97-copy-title__label').textContent = label;
  }

  function buildCopyTitleButton(text) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'a97-copy-title';
    btn.setAttribute('aria-label', '商品名をコピー');
    btn.dataset.copyText = text;
    setCopyButtonState(btn, ICON_COPY, '商品名をコピー');

    function reset() {
      btn.classList.remove('is-copied', 'is-failed');
      setCopyButtonState(btn, ICON_COPY, '商品名をコピー');
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      copyTextToClipboard(btn.dataset.copyText).then(function () {
        btn.classList.remove('is-failed');
        btn.classList.add('is-copied');
        setCopyButtonState(btn, ICON_DONE, 'コピーしました');
        clearTimeout(btn._a97ResetTimer);
        btn._a97ResetTimer = setTimeout(reset, 2000);
      }).catch(function () {
        btn.classList.remove('is-copied');
        btn.classList.add('is-failed');
        setCopyButtonState(btn, ICON_COPY, 'コピーできませんでした');
        clearTimeout(btn._a97ResetTimer);
        btn._a97ResetTimer = setTimeout(reset, 2500);
      });
    });

    return btn;
  }

  // 商品コード / SKU 用のアイコンのみコピーボタン（値は押した瞬間に読むのでバリアント変更に追従する）
  function buildCodeCopyButton(valueEl, labelText) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'a97-copy-code';
    btn.setAttribute('aria-label', (labelText || 'コード') + 'をコピー');
    btn.innerHTML = ICON_COPY;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var text = (valueEl.textContent || '').trim();
      if (!text) return;
      copyTextToClipboard(text).then(function () {
        btn.classList.remove('is-failed');
        btn.classList.add('is-copied');
        btn.innerHTML = ICON_DONE;
        clearTimeout(btn._a97ResetTimer);
        btn._a97ResetTimer = setTimeout(function () {
          btn.classList.remove('is-copied');
          btn.innerHTML = ICON_COPY;
        }, 1500);
      }).catch(function () {
        btn.classList.add('is-failed');
        clearTimeout(btn._a97ResetTimer);
        btn._a97ResetTimer = setTimeout(function () {
          btn.classList.remove('is-failed');
        }, 1500);
      });
    });

    return btn;
  }

  function injectBarcodeCopyButtons() {
    document.querySelectorAll('.product-barcode').forEach(function (block) {
      if (block.querySelector('.a97-copy-code')) return;
      var val = block.querySelector('.product-barcode__value');
      if (!val || !val.textContent.trim()) return;
      var lbl = block.querySelector('.product-barcode__label');
      var labelText = lbl ? lbl.textContent.trim() : '';
      val.insertAdjacentElement('afterend', buildCodeCopyButton(val, labelText));
    });
  }

  var _metaInjected = false;

  function injectProductCatLabel() {
    if (_metaInjected) return;
    if (document.querySelector('.a97-product-meta')) { _metaInjected = true; return; }

    var el = document.getElementById('a97-product-cat-tags');
    if (!el) return;
    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return; }
    var entry = Object.values(data)[0];
    if (!entry) return;

    var catTag = typeof entry === 'object' ? entry.cat : entry;
    var vendor = typeof entry === 'object' ? entry.vendor : '';

    var h1 = document.querySelector('.product-information h1') || document.querySelector('h1');
    if (!h1) return;

    _metaInjected = true;

    // h1を書き換える前に、コピー用の正式名称（Shopifyの商品名そのまま）を確保する
    var fullTitle = normalizeSpace(h1.textContent);
    var copyTitle = fullTitle;

    if (vendor) {
      // 運用ルール上ベンダー名は商品名の先頭、または先頭の【】ブロック直後に入る。
      // その位置にある場合だけ h1 から取り除く（大文字小文字は無視）。
      // 比較は textContent 側で行う。innerHTML では G&G が G&amp;G になり一致しない。
      var text = h1.textContent;
      var prefix = text.match(/^(\s*(?:【[^】]*】\s*)*)/)[1];
      var rest = text.slice(prefix.length);
      // h1 が素のテキストのときだけ書き換える（将来テーマが要素を挟んだ場合は壊さず据え置く）
      if (h1.children.length === 0 && rest.toLowerCase().indexOf(vendor.toLowerCase()) === 0) {
        h1.textContent = prefix + rest.slice(vendor.length).replace(/^\s+/, '').replace(/^[\/／]\s*/, '');
      }
    }

    h1.innerHTML = breakLongBracket(h1.innerHTML);

    // h1の上：カテゴリのみ（バッジ注入の基準要素なので、カテゴリ無しでも空divを置く）
    var wrapper = document.createElement('div');
    wrapper.className = 'a97-product-meta';

    if (catTag && CAT_TAG_MAP[catTag]) {
      var catHandle = CAT_COLLECTION_MAP[catTag];
      var catLink = document.createElement('a');
      catLink.className = 'a97-meta-link';
      catLink.textContent = CAT_TAG_MAP[catTag];
      catLink.href = catHandle ? '/collections/' + catHandle : '#';
      wrapper.appendChild(catLink);
    }

    h1.parentElement.insertBefore(wrapper, h1);

    // h1の下：ベンダーピル ＋ 商品名コピーボタン
    var sub = document.createElement('div');
    sub.className = 'a97-product-sub';

    if (vendor) {
      var pill = document.createElement('a');
      pill.className = 'a97-vendor-pill';
      pill.href = '/collections/vendors?q=' + encodeURIComponent(vendor);

      var pillLabel = document.createElement('span');
      pillLabel.className = 'a97-vendor-pill__label';
      pillLabel.textContent = VENDOR_LABEL;

      var pillName = document.createElement('span');
      pillName.className = 'a97-vendor-pill__name';
      pillName.textContent = vendor;

      pill.appendChild(pillLabel);
      pill.appendChild(pillName);
      sub.appendChild(pill);
    }

    sub.appendChild(buildCopyTitleButton(copyTitle));

    h1.parentElement.insertBefore(sub, h1.nextSibling);
  }

  function injectCSS() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .a97-pts-pill--camp {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: #c8372d;
        color: #fff;
        padding: 3px 10px 3px 4px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 600;
        vertical-align: middle;
      }
      .a97-pts-pill--camp .a97-pts-x {
        background: #fff;
        color: #c8372d;
        border-radius: 14px;
        padding: 0 7px;
        font-size: 11px;
        font-weight: 800;
        line-height: 18px;
      }
      .a97-pts-pill--camp .a97-pts-was {
        font-weight: 400;
        opacity: .85;
      }
      .a97-pts-until {
        font-size: 11px;
        color: #c8372d;
        font-weight: 600;
        margin-top: 3px;
      }
      .a97-pts-tip {
        display: inline-block;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: #e8dcc8;
        color: #854f0b;
        font-size: 9px;
        font-weight: 500;
        text-align: center;
        line-height: 14px;
        margin-left: 3px;
        cursor: pointer;
        vertical-align: middle;
        position: relative;
      }
      .a97-pts-tip-bubble {
        position: absolute;
        bottom: calc(100% + 6px);
        left: 50%;
        transform: translateX(-50%);
        background: #333;
        color: #fff;
        font-size: 11px;
        font-weight: 400;
        padding: 6px 10px;
        border-radius: 6px;
        white-space: normal;
        min-width: 220px;
        max-width: 250px;
        text-align: left;
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.2s;
        z-index: 100;
      }
      .a97-pts-tip-bubble.is-visible {
        opacity: 1;
      }
      .a97-pts-tip-bubble::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border: 5px solid transparent;
        border-top-color: #333;
      }
      .a97-product-meta {
        display: flex !important;
        align-items: center !important;
        gap: 3px !important;
        margin-bottom: 6px !important;
        font-size: 11px !important;
      }
      .a97-product-meta:empty {
        display: none !important;
      }
      .a97-product-meta .a97-meta-link {
        color: #888 !important;
        text-decoration: none !important;
        font-size: 14px !important;
      }
      .a97-product-meta .a97-meta-link:hover {
        color: #555 !important;
        text-decoration: underline !important;
      }
      .a97-product-sub {
        display: flex !important;
        flex-wrap: wrap !important;
        align-items: center !important;
        gap: 8px !important;
        margin: 8px 0 4px !important;
      }
      .a97-vendor-pill {
        display: inline-flex !important;
        align-items: center !important;
        gap: 6px !important;
        padding: 4px 12px !important;
        border: 1px solid #dcdcd8 !important;
        border-radius: 999px !important;
        background: #fff !important;
        font-size: 13px !important;
        text-decoration: none !important;
        line-height: 1.5 !important;
        transition: background .15s ease, border-color .15s ease !important;
      }
      a.a97-vendor-pill:hover {
        background: #f4f4f1 !important;
        border-color: #c2c2bc !important;
        text-decoration: none !important;
      }
      .a97-vendor-pill__label {
        font-size: 10px !important;
        letter-spacing: .04em !important;
        color: #a3a39c !important;
      }
      .a97-vendor-pill__name {
        font-size: 13px !important;
        font-weight: 600 !important;
        color: #333 !important;
      }
      a.a97-vendor-pill:hover .a97-vendor-pill__name {
        color: #111 !important;
      }
      .a97-copy-title {
        display: inline-flex !important;
        align-items: center !important;
        gap: 5px !important;
        padding: 4px 10px !important;
        border: 1px solid #e2e2de !important;
        border-radius: 6px !important;
        background: #fff !important;
        color: #8a8a84 !important;
        font-size: 11px !important;
        line-height: 1.5 !important;
        cursor: pointer !important;
        transition: color .15s ease, background .15s ease, border-color .15s ease !important;
      }
      .a97-copy-title:hover {
        color: #333 !important;
        background: #f7f7f5 !important;
        border-color: #c8c8c2 !important;
      }
      .a97-copy-title:focus-visible {
        outline: 2px solid #4a90d9 !important;
        outline-offset: 2px !important;
      }
      .a97-copy-title svg {
        width: 13px !important;
        height: 13px !important;
        flex: 0 0 auto !important;
        pointer-events: none !important;
      }
      .a97-copy-title.is-copied {
        color: #3f8a52 !important;
        background: #f3faf5 !important;
        border-color: #a8d3b3 !important;
      }
      .a97-copy-title.is-failed {
        color: #c8503f !important;
        background: #fdf5f4 !important;
        border-color: #e8b8b0 !important;
      }
      .a97-copy-code {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        align-self: center !important;
        flex: 0 0 auto !important;
        width: 20px !important;
        height: 20px !important;
        padding: 0 !important;
        border: 0 !important;
        border-radius: 4px !important;
        background: transparent !important;
        color: #b6b6b0 !important;
        cursor: pointer !important;
      }
      .a97-copy-code:hover {
        color: #555 !important;
        background: #f0f0ed !important;
      }
      .a97-copy-code:focus-visible {
        outline: 2px solid #4a90d9 !important;
        outline-offset: 1px !important;
      }
      .a97-copy-code svg {
        width: 12px !important;
        height: 12px !important;
        pointer-events: none !important;
      }
      .a97-copy-code.is-copied {
        color: #3f8a52 !important;
        background: transparent !important;
      }
      .a97-copy-code.is-failed {
        color: #c8503f !important;
        background: transparent !important;
      }
      @media (prefers-reduced-motion: reduce) {
        .a97-vendor-pill,
        .a97-copy-title {
          transition: none !important;
        }
      }
      .product-form-buttons:has(.gpo-container) .quantity-selector-wrapper {
        flex-basis: 100% !important;
      }
    `;
    document.head.appendChild(style);
  }

  function applyZeroPricePlaceholder(priceSpan) {
    if (priceSpan.parentElement.querySelector('.a97-zero-price-msg')) return;
    priceSpan.style.display = 'none';
    var msg = document.createElement('span');
    msg.className = 'a97-zero-price-msg';
    msg.textContent = '金額は選択後に表示されます';
    msg.style.cssText = 'font-size:14px; color:#888;';
    priceSpan.insertAdjacentElement('afterend', msg);
  }

  function removeZeroPricePlaceholder(container, priceSpan, newText) {
    var zeroMsg = container.querySelector('.a97-zero-price-msg');
    if (zeroMsg) zeroMsg.remove();
    priceSpan.style.display = '';
    if (priceSpan.textContent !== newText) {
      priceSpan.textContent = newText;
    }
  }

  function refreshAll() {
    updateGPOBadge();
    showPointsStandalone();
    observePrices();
  }

  function isCustomerLoggedIn() {
    try {
      var epSettings = document.getElementById('easy-points-widget-settings');
      if (epSettings) {
        var data = JSON.parse(epSettings.textContent);
        return !!(data.data && data.data.customer);
      }
    } catch(e) {}
    return false;
  }

  function showDiscountBadge(container) {
    var old = document.getElementById(DISCOUNT_ID);
    if (old) old.remove();

    var saleEl = container.querySelector('.price__sale:not(.price__hidden)');
    if (!saleEl) return;

    var salePriceSpan = saleEl.querySelector('span.price-item--sale');
    var compareSpan = saleEl.querySelector('span.compare-at-price');
    if (!salePriceSpan || !compareSpan) return;

    var salePrice = parseInt((salePriceSpan.textContent || '').replace(/[^\d]/g, ''), 10) || 0;
    var comparePrice = parseInt((compareSpan.textContent || '').replace(/[^\d]/g, ''), 10) || 0;
    if (comparePrice <= 0 || salePrice <= 0 || salePrice >= comparePrice) return;

    var diff = comparePrice - salePrice;
    var diffStr = String(diff).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    var badge = document.createElement('span');
    badge.id = DISCOUNT_ID;
    badge.textContent = diffStr + '円OFF';
    Object.assign(badge.style, {
      fontSize:      '11px',
      fontWeight:    '500',
      color:         '#e24b4a',
      marginLeft:    '6px',
      verticalAlign: 'middle'
    });
    compareSpan.insertAdjacentElement('afterend', badge);
  }

  function showPoints(container, basePrice, gpoAmount) {
    if (!window.location.pathname.startsWith('/products/')) return;
    var oldPts = document.getElementById(POINTS_ID);
    if (oldPts) oldPts.remove();
    if (getPointExclusion().noEarn) return;   // 付与対象外（no-easy-points）なら獲得表示を出さない
    _ptsArgs = [container, basePrice, gpoAmount];
    var rate = readRate();
    if (!rate) {
      // 1% で出してから倍率に差し替わる見た目を避けるため、レートが届くまで出さない
      if (!_rateFailed) { loadRate(); return; }
      rate = RATE_FALLBACK;
    }
    var yen = basePrice + gpoAmount;
    var points = Math.round(yen / rate.cv * rate.pv);
    if (points <= 0) return;

    var wrapper = document.createElement('div');
    wrapper.id = POINTS_ID;
    wrapper.style.cssText = 'margin-top:6px;';

    var pill = document.createElement('span');
    var until = rate.campaign ? untilText() : '';
    if (rate.campaign) {
      // キャンペーン中: 「5倍」＋「18 → 88 ポイント獲得」。通常値は通常レートから出す
      var normal = rate.base ? Math.round(yen / rate.base.cv * rate.base.pv) : 0;
      pill.className = 'a97-pts-pill--camp';
      var x = document.createElement('span');
      x.className = 'a97-pts-x';
      x.textContent = pctLabel(rate);
      var tx = document.createElement('span');
      if (normal > 0 && normal !== points) {
        var was = document.createElement('span');
        was.className = 'a97-pts-was';
        was.textContent = num(normal);
        tx.appendChild(was);
        tx.appendChild(document.createTextNode(' → ' + num(points) + ' ポイント獲得'));
      } else {
        tx.textContent = num(points) + ' ポイント獲得';
      }
      pill.appendChild(x);
      pill.appendChild(tx);
    } else {
      pill.textContent = num(points) + ' ポイント獲得';
      Object.assign(pill.style, {
        display:       'inline-block',
        background:    '#faeeda',
        color:         '#854f0b',
        padding:       '2px 8px',
        borderRadius:  '20px',
        fontSize:      '11px',
        fontWeight:    '500'
      });
    }

    var tip = document.createElement('span');
    tip.className = 'a97-pts-tip';
    tip.textContent = '?';
    var bubble = document.createElement('span');
    bubble.className = 'a97-pts-tip-bubble';
    // 付与の計算方法を明記する（表示は商品単価からの目安。実際の付与はアプリが注文金額から計算する）
    bubble.textContent = 'ポイントは税込のご注文金額（ポイント・クーポン利用分を除く）の ' + pctLabel(rate) +
      (rate.campaign && rate.base ? '（通常 ' + pctLabel(rate.base) + '）' : '') +
      ' で、1ポイント未満は四捨五入されます。この表示は商品単価からの目安です。';
    tip.appendChild(bubble);
    tip.addEventListener('click', function(e) {
      e.stopPropagation();
      var isVis = bubble.classList.contains('is-visible');
      bubble.classList.toggle('is-visible');
      if (!isVis) {
        setTimeout(function() { bubble.classList.remove('is-visible'); }, 3000);
      }
    });

    wrapper.appendChild(pill);
    wrapper.appendChild(tip);

    if (rate.campaign) {
      var u = document.createElement('div');
      u.className = 'a97-pts-until';
      u.textContent = 'ポイント' + pctLabel(rate) + '還元キャンペーン' + (until ? '' : '中') +
        (rate.base ? '（通常 ' + pctLabel(rate.base) + '）' : '') + (until ? ' ' + until : '');
      wrapper.appendChild(u);
    }

    if (!isCustomerLoggedIn()) {
      var note = document.createElement('div');
      note.textContent = '※会員登録・ログインが必要です';
      Object.assign(note.style, { fontSize: '11px', color: '#999', marginTop: '2px' });
      wrapper.appendChild(note);
    }

    container.appendChild(wrapper);
  }

  function showPointsStandalone() {
    if (document.getElementById(POINTS_ID)) return;
    var container = document.querySelector('.text-block [ref="priceContainer"]');
    if (!container) return;
    var priceEl = container.querySelector('.price__sale:not(.price__hidden) span.price-item--sale') ||
                  container.querySelector('.price__regular:not(.price__hidden) span.price') ||
                  container.querySelector('span.price');
    if (!priceEl) return;
    var basePrice = parseInt((priceEl.textContent || '').replace(/[^\d]/g, ''), 10) || 0;
    if (basePrice > 0) {
      showDiscountBadge(container);
      showPoints(container, basePrice, 0);
    }
  }

  function parseJPY(text) {
    return parseInt((text || '').replace(/[¥,\s]/g, '').replace('JPY', ''), 10) || 0;
  }

  function updateGPOBadge() {
    var gpoEl     = document.querySelector('.gpo-total-text');
    var container = document.querySelector('.text-block [ref="priceContainer"]');

    var old = document.getElementById(BADGE_ID);
    if (old) old.remove();
    var oldPts = document.getElementById(POINTS_ID);
    if (oldPts) oldPts.remove();
    var oldDisc = document.getElementById(DISCOUNT_ID);
    if (oldDisc) oldDisc.remove();

    if (!container) return;

    if (!gpoEl || !gpoEl.querySelector('.money')) {
      showDiscountBadge(container);
      var priceEl = container.querySelector('.price__sale:not(.price__hidden) span.price-item--sale') ||
                    container.querySelector('.price__regular:not(.price__hidden) span.price') ||
                    container.querySelector('span.price');
      var basePrice = priceEl ? parseInt((priceEl.textContent || '').replace(/[^\d]/g, ''), 10) || 0 : 0;
      if (basePrice > 0) showPoints(container, basePrice, 0);
      return;
    }

    var moneyEl = gpoEl.querySelector('.money');

    var gpoStyle  = window.getComputedStyle(gpoEl);
    var isVisible = gpoStyle.display !== 'none' && gpoStyle.visibility !== 'hidden';
    var amount    = parseJPY(moneyEl.textContent);

    var variantDataEl = document.getElementById('airsoft97-variant-data');
    if (variantDataEl) {
      var variantData = JSON.parse(variantDataEl.textContent);
      var isZeroPrice = variantData.every(function(v) { return v.price === 0; });
      if (isZeroPrice) {
        var priceSpan = container.querySelector('.price__regular:not(.price__hidden) span.price') ||
                        container.querySelector('.price__sale:not(.price__hidden) span.price-item--sale') ||
                        container.querySelector('span.price');
        if (priceSpan) {
          if (amount > 0) {
            var newText = String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' 円';
            removeZeroPricePlaceholder(container, priceSpan, newText);
          } else {
            applyZeroPricePlaceholder(priceSpan);
          }
        }
        var compareSpan = container.querySelector('span.compare-at-price');
        if (compareSpan) compareSpan.style.visibility = 'hidden';
        gpoEl.style.visibility = 'hidden';
        showPoints(container, 0, amount);
        return;
      }
    }

    showDiscountBadge(container);

    if (!isVisible || amount <= 0) {
      var priceEl = container.querySelector('.price__sale:not(.price__hidden) span.price-item--sale') ||
                    container.querySelector('.price__regular:not(.price__hidden) span.price') ||
                    container.querySelector('span.price');
      var basePrice = priceEl ? parseInt((priceEl.textContent || '').replace(/[^\d]/g, ''), 10) || 0 : 0;
      if (basePrice > 0) showPoints(container, basePrice, 0);
      return;
    }

    var amountStr = String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var badge = document.createElement('div');
    badge.id = BADGE_ID;
    badge.textContent = 'オプション +' + amountStr + '円';
    Object.assign(badge.style, {
      display:      'block',
      background:   '#f8f8f6',
      borderRadius: '8px',
      padding:      '8px 10px',
      fontSize:     '12px',
      color:        '#666',
      marginTop:    '8px'
    });
    container.appendChild(badge);

    var basePrice = 0;
    var priceEl = container.querySelector('.price__sale:not(.price__hidden) span.price-item--sale') ||
                  container.querySelector('.price__regular:not(.price__hidden) span.price') ||
                  container.querySelector('span.price');
    if (priceEl) basePrice = parseInt((priceEl.textContent || '').replace(/[^\d]/g, ''), 10) || 0;
    showPoints(container, basePrice, amount);
  }

  var _badgeTimer = null;
  var _priceUpdating = false;

  function updateGPOBadgeDebounced() {
    clearTimeout(_badgeTimer);
    _badgeTimer = setTimeout(function () {
      _priceUpdating = true;
      updateGPOBadge();
      setTimeout(function () { _priceUpdating = false; }, 300);
    }, 200);
  }

  function observePrices() {
    var targets = [
      document.querySelector('.text-block [ref="priceContainer"]'),
      document.querySelector('.sticky-add-to-cart__price')
    ].filter(Boolean);

    targets.forEach(function (target) {
      if (target._a97Observed) return;
      target._a97Observed = true;
      new MutationObserver(function (mutations) {
        if (_priceUpdating) return;
        var needsUpdate = mutations.some(function (m) { return m.type === 'childList'; });
        if (needsUpdate) {
          updateGPOBadgeDebounced();
          showPointsStandalone();
        }
      }).observe(target, { childList: true, subtree: true });
    });
  }

  function observeGPO() {
    var target = document.querySelector('.gpo-app') ||
                 document.querySelector('.gpo-container');
    if (!target || target._a97GPOObserved) return;
    target._a97GPOObserved = true;
    new MutationObserver(updateGPOBadgeDebounced).observe(target, {
      attributes:  true,
      childList:   true,
      subtree:     true,
      characterData: true
    });
  }

  function startPolling() {
    var count = 0;
    var timer = setInterval(function () {
      count++;
      updateGPOBadgeDebounced();
      observeGPO();
      var gpoAppEl = document.querySelector('.gpo-app');
      if ((gpoAppEl && gpoAppEl._a97GPOObserved) || count >= 150) {
        clearInterval(timer);
      }
    }, 100);
  }

  function observeVariantChanges() {
    document.addEventListener('variant:update', function() {
      refreshAll();
      setTimeout(refreshAll, 1500);
    });

    var textBlock = document.querySelector('.text-block');
    if (textBlock && !textBlock._a97TBObserved) {
      textBlock._a97TBObserved = true;
      new MutationObserver(function(mutations) {
        var containerReplaced = mutations.some(function(m) {
          return m.type === 'childList' && Array.from(m.addedNodes).some(function(n) {
            return n.nodeType === 1 && (n.getAttribute('ref') === 'priceContainer' || n.querySelector('[ref="priceContainer"]'));
          });
        });
        if (containerReplaced) {
          setTimeout(refreshAll, 50);
        }
      }).observe(textBlock, { childList: true, subtree: true });
    }
  }

  function init() {
    if (!window.location.pathname.startsWith('/products/')) return;

    injectCSS();
    injectProductCatLabel();
    injectBarcodeCopyButtons();

    var epSettings = document.getElementById('easy-points-widget-settings');
    if (epSettings) {
      try {
        var data = JSON.parse(epSettings.textContent);
        if (data.data && data.data.request && data.data.request.pageType === 'product') {
          data.data.request.pageType = 'other';
          epSettings.textContent = JSON.stringify(data);
        }
      } catch(e) {}
    }
    observePrices();
    updateGPOBadge();
    observeGPO();
    startPolling();
    showPointsStandalone();
    observeVariantChanges();
  }

  window.addEventListener('load', function () {
    if (!window.location.pathname.startsWith('/products/')) return;
    updateGPOBadge();
    observeGPO();
    showPointsStandalone();
    injectBarcodeCopyButtons();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // 0円フラッシュ防止: DOMContentLoaded を待たず即実行
  (function earlyZeroPriceCheck() {
    if (!window.location.pathname.startsWith('/products/')) return;
    var variantDataEl = document.getElementById('airsoft97-variant-data');
    if (!variantDataEl) return;
    try {
      var variantData = JSON.parse(variantDataEl.textContent);
      if (!variantData.every(function(v) { return v.price === 0; })) return;
      var priceSpan = document.querySelector('.text-block [ref="priceContainer"] span.price') ||
                      document.querySelector('.text-block [ref="priceContainer"] span.price-item--sale');
      if (priceSpan) {
        applyZeroPricePlaceholder(priceSpan);
      }
    } catch(e) {}
  })();

  // h1ちらつき防止: DOMContentLoaded を待たず即実行
  (function earlyProductMeta() {
    if (!window.location.pathname.startsWith('/products/')) return;
    injectCSS();
    injectProductCatLabel();
    injectBarcodeCopyButtons();
    showPointsStandalone();
    var cloak = document.getElementById('a97-product-cloak');
    if (cloak) cloak.remove();
  })();

})();

// 自動セットチェックボックスのロック
(function () {
  if (!window.location.pathname.startsWith('/products/')) return;

  const _autoSetLocked = new WeakSet();

  function lockAutoSetCheckboxes() {
    document.querySelectorAll('.gpo-element').forEach(el => {
      const _lbl = el.querySelector('.gpo-label .label-content');
      const labelText = (_lbl && _lbl.textContent) || '';
      if (!labelText.includes('自動セット')) return;

      el.querySelectorAll('input[type="checkbox"]').forEach(chk => {
        if (_autoSetLocked.has(chk)) return;

        // 非表示中は .checked=false のため checked 属性も見る
        const initiallyChecked = chk.checked || chk.hasAttribute('checked');
        if (!initiallyChecked) return;   // ← WeakSetに入れずに戻る（後で再評価できる）

        _autoSetLocked.add(chk);

        chk.addEventListener('change', function () {
          if (!this.checked) showLockMessage(this);
        });

        const label = document.querySelector(`label[for="${chk.id}"]`);
        if (label) {
          label.addEventListener('click', function (e) {
            if (chk.checked) {
              e.preventDefault();
              showLockMessage(chk);
            }
          }, true);
        }
      });
    });
  }

  function showLockMessage(chkEl) {
    const wrapper = chkEl.closest('.gpo-choicelist');
    if (!wrapper) return;

    const existing = wrapper.querySelector('.autoset-lock-msg');
    if (existing) {
      clearTimeout(existing._timer);
      existing.remove();
    }

    const msg = document.createElement('span');
    msg.className = 'autoset-lock-msg';
    msg.textContent = 'パッケージに含まれるため外せません';
    msg.style.cssText = `
      display: block;
      font-size: 11px;
      color: #e05a5a;
      margin: 2px 0 4px 26px;
      animation: autoset-fadein 0.15s ease;
    `;
    wrapper.appendChild(msg);

    msg._timer = setTimeout(() => {
      msg.style.transition = 'opacity 0.4s';
      msg.style.opacity = '0';
      setTimeout(() => msg.remove(), 400);
    }, 2500);
  }

  if (!document.getElementById('autoset-lock-style')) {
    const s = document.createElement('style');
    s.id = 'autoset-lock-style';
    s.textContent = `@keyframes autoset-fadein { from { opacity:0; transform:translateY(-4px); } to { opacity:1; transform:translateY(0); } }`;
    document.head.appendChild(s);
  }

  // .gpo-app の出現を待ってから observer を張る（DOMContentLoadedでは間に合わない）
  let _bound = false;
  function bindGpoObserver() {
    if (_bound) return true;
    const gpoApp = document.querySelector('.gpo-app');
    if (!gpoApp) return false;
    _bound = true;

    lockAutoSetCheckboxes();

    let updating = false;
    new MutationObserver(() => {
      if (updating) return;
      updating = true;
      lockAutoSetCheckboxes();
      updating = false;
    }).observe(gpoApp, { subtree: true, childList: true });

    return true;
  }

  if (!bindGpoObserver()) {
    const bodyObs = new MutationObserver(() => {
      if (bindGpoObserver()) bodyObs.disconnect();
    });
    bodyObs.observe(document.body, { childList: true, subtree: true });
  }
})();

// 商品詳細ページ: バッジ注入（カテゴリラベルの上）
(function initProductPageBadges() {
  if (!window.location.pathname.startsWith('/products/')) return;

  var _badgeInjected = false;

  function loadBadgeData() {
    var el = document.getElementById('a97-card-badges');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function getProductHandle() {
    var m = window.location.pathname.match(/\/products\/([^?#/]+)/);
    return m ? m[1] : null;
  }

  function injectProductBadges() {
    if (_badgeInjected) return;
    var meta = document.querySelector('.a97-product-meta');
    if (!meta) return;
    var handle = getProductHandle();
    if (!handle) return;

    _badgeInjected = true;

    fetch('/products/' + handle + '.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var productTags = [];
        if (data.product && data.product.tags) {
          productTags = typeof data.product.tags === 'string'
            ? data.product.tags.split(', ')
            : data.product.tags;
        }

        var badges = loadBadgeData();
        if (!badges.length) return;

        var matching = badges.filter(function (b) {
          if (!b.tags) return false;
          var requiredTags = b.tags.split(',').map(function (t) { return t.trim(); });
          return requiredTags.every(function (rt) { return productTags.includes(rt); });
        });
        if (!matching.length) return;

        var wrapper = document.createElement('div');
        wrapper.className = 'a97-product-badges';

        matching.forEach(function (b) {
          var el = document.createElement('span');
          el.className = 'a97-badge';
          el.textContent = b.text;
          // 2026-07-30 商品カードのバッジ寸法に統一
          // （Fabric純正 .product-badges__badge の実測値: 13px / 4px 10px / 角丸2px / uppercase）
          // --badge-* はFabricカード側のインライン変数で商品ページには継承されないため
          // fallback値が採用される
          el.style.cssText =
            'display:inline-block;padding:4px 10px;' +
            'border-radius:var(--badge-border-radius,2px);' +
            'font-size:var(--font-size--xs,13px);' +
            'font-weight:var(--badge-font-weight,var(--font-secondary--weight,400));' +
            'text-transform:var(--badge-text-transform,uppercase);' +
            'line-height:1.7;margin-right:6px;' +
            'background:' + b.bg + ';color:' + b.color + ';';
          wrapper.appendChild(el);
        });

        meta.parentElement.insertBefore(wrapper, meta);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectProductBadges);
  } else {
    injectProductBadges();
  }

  var obs = new MutationObserver(function () {
    if (!_badgeInjected) injectProductBadges();
    if (_badgeInjected) obs.disconnect();
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();

// 商品詳細ページ: variant-picker スウォッチ在庫切れ表示
(function initVariantSoldoutDisplay() {
  if (!window.location.pathname.startsWith('/products/')) return;

  var DYNAMIC_STYLE_ID = 'a97-variant-soldout-dynamic';
  var BASE_STYLE_ID = 'a97-variant-soldout-style';
  var SOLDOUT_LABEL_ID = 'a97-variant-soldout-label';
  var _refreshing = false;

  // option値 → true のマップ（在庫切れバリアント）
  var soldoutMap = {};

  function injectBaseCSS() {
    if (document.getElementById(BASE_STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = BASE_STYLE_ID;
    style.textContent =
      '#' + SOLDOUT_LABEL_ID + ' {' +
        'display: block;' +
        'background: #fff0f0;' +
        'color: #d63a3a;' +
        'font-size: 11px;' +
        'font-weight: 600;' +
        'padding: 3px 14px;' +
        'border-radius: 4px;' +
        'border: 1px solid #f0c8c8;' +
        'text-align: center;' +
        'width: fit-content;' +
      '}' +
      // ピルが入った行は align-items:center にして、選択ラベルが縦に引き伸ばされる
      // （＝選択リングの楕円化）のを防ぐ。同時にピルがスウォッチ中央に揃う。
      // swatch/テキストボタンどちらの fieldset でも有効。
      'variant-picker fieldset:has(#' + SOLDOUT_LABEL_ID + ') {' +
        'align-items: center;' +
      '}';
    document.head.appendChild(style);
  }

  // soldoutMap に基づいて動的CSSを生成・更新
  // 接尾辞は join 後ではなく各セレクタに付与する（先頭バリアントに付き忘れるとラベルごと消えるため）
  function updateDynamicCSS() {
    var keys = Object.keys(soldoutMap);
    var style = document.getElementById(DYNAMIC_STYLE_ID);

    if (!keys.length) {
      if (style) style.textContent = '';
      return;
    }

    if (!style) {
      style = document.createElement('style');
      style.id = DYNAMIC_STYLE_ID;
      document.head.appendChild(style);
    }

    var selectors = keys.map(function (val) {
      return 'variant-picker label:has(input[value="' + CSS.escape(val) + '"])';
    });

    function joinSel(suffix) {
      return selectors.map(function (s) { return s + suffix; }).join(',\n');
    }

    style.textContent =
      joinSel(':has(.swatch) .swatch') + ' {\n' +
      '  opacity: 0.35;\n' +
      '  position: relative;\n' +
      '  overflow: hidden;\n' +
      '}\n' +
      joinSel(':has(.swatch) .swatch::after') + ' {\n' +
      '  content: "";\n' +
      '  position: absolute;\n' +
      '  top: 0; left: 0;\n' +
      '  width: 100%; height: 100%;\n' +
      '  background: linear-gradient(to top right, transparent 43%, #888 43%, #888 57%, transparent 57%);\n' +
      '  pointer-events: none;\n' +
      '  border-radius: inherit;\n' +
      '}\n' +
      joinSel(':has(.swatch) .variant-option__strikethrough') + ' {\n' +
      '  display: none !important;\n' +
      '}\n' +
      joinSel(':not(:has(.swatch)) .variant-option__button-label__text') + ' {\n' +
      '  opacity: 0.5;\n' +
      '}\n';
  }

  function buildSoldoutMap() {
    var vp = document.querySelector('variant-picker');
    if (!vp) return;

    // 非選択バリアント: SVG表示状態で判定
    vp.querySelectorAll('.variant-option__button-label').forEach(function (label) {
      var inp = label.querySelector('input[type="radio"]');
      var svg = label.querySelector('.variant-option__strikethrough');
      if (inp && svg && getComputedStyle(svg).display !== 'none') {
        soldoutMap[inp.value] = true;
      }
    });

    // 選択中バリアント: script JSON の available で判定
    updateMapFromScript(vp);
  }

  function updateMapFromScript(vp) {
    var scriptEl = vp.querySelector('script[type="application/json"]');
    if (!scriptEl) return;
    try {
      var data = JSON.parse(scriptEl.textContent);
      var key = data.option1 || data.title;
      if (!key) return;
      if (data.available === false) {
        soldoutMap[key] = true;
      } else if (soldoutMap[key]) {
        delete soldoutMap[key];
      }
    } catch (e) {}
  }

  function updateSoldoutLabel() {
    var vp = document.querySelector('variant-picker');
    if (!vp) return;

    var checkedInput = vp.querySelector('input[type="radio"]:checked');
    var isSoldout = checkedInput && soldoutMap[checkedInput.value];

    var existing = document.getElementById(SOLDOUT_LABEL_ID);

    if (isSoldout) {
      var checkedLabel = checkedInput.closest('label');

      if (!existing) {
        existing = document.createElement('div');
        existing.id = SOLDOUT_LABEL_ID;
        existing.textContent = '一時品切中';
      }

      // fieldset は flex レイアウト。ピルは行末に append し、
      // align-items:center（injectBaseCSS）で縦中央に揃える。
      if (checkedLabel && checkedLabel.parentElement) {
        if (existing.parentElement !== checkedLabel.parentElement) {
          checkedLabel.parentElement.appendChild(existing);
        }
      }
      existing.style.display = '';
    } else {
      if (existing) existing.style.display = 'none';
    }
  }

  function refresh() {
    if (_refreshing) return;

    _refreshing = true;
    var vp = document.querySelector('variant-picker');
    if (vp) updateMapFromScript(vp);
    updateDynamicCSS();
    updateSoldoutLabel();
    _refreshing = false;
  }

  function init() {
    injectBaseCSS();

    var vp = document.querySelector('variant-picker');
    if (!vp) return;            // ← 追加。未挿入なら抜ける（下の vpObs が挿入後に再実行する）

    buildSoldoutMap();
    updateDynamicCSS();
    updateSoldoutLabel();

    if (!vp._a97SoldoutObs) {
      vp._a97SoldoutObs = true;

      // childList のみ監視（attributes を含めると無限ループ）
      new MutationObserver(function () {
        setTimeout(refresh, 60);
      }).observe(vp, { childList: true, subtree: true });
    }

    document.addEventListener('variant:update', function () {
      setTimeout(refresh, 150);
    });

    vp.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') {
        updateSoldoutLabel();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // variant-picker が遅延レンダリングされる場合
  var vpObs = new MutationObserver(function () {
    var vp = document.querySelector('variant-picker');
    if (vp && !vp._a97SoldoutObs) {
      init();
      vpObs.disconnect();
    }
  });
  vpObs.observe(document.body, { childList: true, subtree: true });
})();

// カートに追加の即時フィードバック（カートバッジのスピナー）＋ 追加がブロックされたことの検知
//
// 旧 initCartBadgeSpinner は「クリックで点灯 → カートバッジの数字が変わったら消灯」
// だけの実装だった。GPOの必須項目未選択のように追加そのものが click 段階で止められると
// 数字が永遠に変わらないため、スピナーが無限に回り続けていた（実測: submitもfetchも飛ばない）。
//
// 終了条件を3つに増やす:
//   1. 成功    … cart-icon の中身が書き換わった
//   2. ブロック … クリックしたのに form の submit が発火しない
//   3. 保険    … WATCHDOG_MS 経過（原因不明の失敗でも必ず止める）
//
// 2. は誤検知（単に処理が遅いだけ）を避けるため、外部に問い合わせてから確定させる。
//   document に 'a97:cart-add-probe' を投げ、detail.blocked を true にしてくれる
//   リスナー（gpo-required-fix.js など）がいればブロック確定。
//   誰も答えなければ BLOCK_TRIES 回まで待ち直し、それでも submit が来なければ
//   スピナーだけ止める（イベントは投げない）。
//   確定時は 'a97:cart-add-blocked' を document に投げる。ここでは何を表示するかは決めない。
(function initAddToCartFeedback() {
  var STYLE_ID      = 'a97-cart-spinner-style';
  var LOADING_CLASS = 'a97-cart-loading';
  var CART_FORM_SEL = 'form[action*="/cart/add"]';
  var ATC_BTN_SEL   = 'button[name="add"], button[type="submit"], input[type="submit"]';

  var BLOCK_MS    = 400;    // クリック後この間隔で submit が来たか確認する
  var BLOCK_TRIES = 6;      // 誰もブロックと答えない場合はこの回数まで待ち直す（約2.4秒）
  var WATCHDOG_MS = 10000;  // 何が起きても必ず消灯する最終保険

  if (!document.getElementById(STYLE_ID)) {
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '@keyframes a97-cart-spin{to{transform:rotate(360deg)}}' +
      'cart-icon.' + LOADING_CLASS + ' .cart-bubble{' +
        'display:flex!important;clip:auto!important;width:20px!important;height:20px!important;' +
        'overflow:visible!important;position:absolute!important;' +
        'animation:a97-cart-spin .7s linear infinite!important' +
      '}' +
      'cart-icon.' + LOADING_CLASS + ' .cart-bubble__background{' +
        'background:conic-gradient(rgb(3,3,2) 270deg,transparent 270deg)!important' +
      '}' +
      'cart-icon.' + LOADING_CLASS + ' .cart-bubble__text{visibility:hidden!important}';
    document.head.appendChild(s);
  }

  function spinOn() {
    var ci = document.querySelector('cart-icon');
    if (ci) ci.classList.add(LOADING_CLASS);
  }

  function spinOff() {
    document.querySelectorAll('cart-icon.' + LOADING_CLASS).forEach(function (ci) {
      ci.classList.remove(LOADING_CLASS);
    });
  }

  // 成功時の消灯。旧実装は .cart-bubble__text-count を読み込み時に1回だけ掴んでいたため、
  // Fabric が cart-icon ごと差し替えると監視が切れていた。親要素を見ることで作り直されても効く。
  // class の書き換えは attributes を監視していないので自己ループしない。
  function watchCartIcon() {
    var ci = document.querySelector('cart-icon');
    var host = ci && ci.parentElement;
    if (!host || host._a97SpinObs) return;
    host._a97SpinObs = true;
    new MutationObserver(function () { spinOff(); })
      .observe(host, { childList: true, subtree: true, characterData: true });
  }

  function askBlocked() {
    var ev;
    try {
      ev = new CustomEvent('a97:cart-add-probe', { detail: { blocked: false } });
    } catch (e) {
      return false;
    }
    document.dispatchEvent(ev);
    return !!ev.detail.blocked;
  }

  var pending = null;

  function clearPending() {
    if (!pending) return;
    clearTimeout(pending.timer);
    clearTimeout(pending.watchdog);
    pending = null;
  }

  function startPending() {
    clearPending();
    spinOn();
    watchCartIcon();

    var state = { submitted: false, tries: 0, timer: null, watchdog: null };
    pending = state;

    state.watchdog = setTimeout(function () {
      if (pending === state) clearPending();
      spinOff();
    }, WATCHDOG_MS);

    state.timer = setTimeout(function check() {
      if (pending !== state) return;
      // submit まで進んだ＝追加処理は動いている。消灯は cart-icon 監視／ウォッチドッグに任せる。
      if (state.submitted) return;

      if (askBlocked()) {
        clearPending();
        spinOff();
        document.dispatchEvent(new CustomEvent('a97:cart-add-blocked'));
        return;
      }
      if (++state.tries < BLOCK_TRIES) {
        state.timer = setTimeout(check, BLOCK_MS);
        return;
      }
      // 誰もブロックと答えないのに submit も来ない＝原因不明。スピナーだけ止めておく。
      clearPending();
      spinOff();
    }, BLOCK_MS);
  }

  document.addEventListener('click', function (e) {
    // スクリプトからの click は無視する。
    // GPO はクローンボタン → オリジナルボタンへ click を中継し、
    // gpo-required-fix.js もエラー表示のためにクローンを click するため、
    // それらで再点灯すると消灯済みのスピナーがまた回り出す。
    // スピナーはユーザー操作へのフィードバックなので、信頼済みイベントだけを見れば足りる。
    if (!e.isTrusted) return;

    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest(ATC_BTN_SEL);
    if (!btn) return;

    var form = btn.closest(CART_FORM_SEL);
    if (!form && btn.form && /\/cart\/add/.test(btn.form.getAttribute('action') || '')) {
      form = btn.form;
    }
    if (!form) return;

    startPending();
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches(CART_FORM_SEL)) return;
    if (pending) pending.submitted = true;
  }, true);

  watchCartIcon();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartIcon);
  }
})();

// 商品詳細ページ: 従属バリアント最適化
// （種類×金額の2軸で、存在しない組み合わせの非表示＋切替の即時反映＋実在在庫切れの品切れ表示）
(function initDependentVariantFix() {
  if (!window.location.pathname.startsWith('/products/')) return;

  var HIDE_STYLE_ID = 'a97-dvf-hide';
  var NEUTRALIZE_STYLE_ID = 'a97-dvf-neutralize';
  var SOLDOUT_STYLE_ID = 'a97-dvf-soldout';
  var SOLDOUT_BASE_ID = 'a97-dvf-soldout-base';
  var PILL_ID = 'a97-dvf-soldout-label';
  var CLOAK_ID = 'a97-amt-cloak';
  var SEP = '\u0001';   // 値の連結キー用のセパレータ（商品データに出てこない制御文字）
  var MX = null;          // "o1o2" → {id, price, avail, sku, barcode}
  var O1_ALL = [];        // 全 option1 値（重複なし・DOM/JSON順）
  var O2_ALL = [];        // 全 option2 値（重複なし）
  var busy = false;       // 自動選択の再入防止
  var syncing = false;    // 品切れ表示同期の再入防止

  function getHandle() {
    var m = window.location.pathname.match(/\/products\/([^?#/]+)/);
    return m ? m[1] : null;
  }
  function key(a, b) { return a + SEP + b; }
  function fmtYen(y) { return String(y).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' 円'; }

  function vp() { return document.querySelector('variant-picker'); }
  function fieldsets() { var v = vp(); return v ? v.querySelectorAll('fieldset') : []; }
  function checkedValue(fs) { var i = fs && fs.querySelector('input[type="radio"]:checked'); return i ? i.value : null; }

  function priceSpan() {
    var c = document.querySelector('.text-block [ref="priceContainer"]');
    if (!c) return null;
    return c.querySelector('.price__regular:not(.price__hidden) span.price') ||
           c.querySelector('.price__sale:not(.price__hidden) span.price-item--sale') ||
           c.querySelector('span.price');
  }
  function setPrice(yen) { var el = priceSpan(); if (el) el.textContent = fmtYen(yen); }
  function setCartId(id) {
    document.querySelectorAll('input[name="id"]').forEach(function (i) { i.value = String(id); });
  }

  function styleEl(id) {
    var s = document.getElementById(id);
    if (!s) { s = document.createElement('style'); s.id = id; document.head.appendChild(s); }
    return s;
  }
  function hideStyle() { return styleEl(HIDE_STYLE_ID); }

  // 選択中の種類(o1)に存在しない金額(o2)を :has() で非表示（Fabric再描画でも消えない）
  function updateHideCSS(o1) {
    var invalid = O2_ALL.filter(function (o2) { return !MX[key(o1, o2)]; });
    if (!invalid.length) { hideStyle().textContent = ''; return; }
    hideStyle().textContent = invalid.map(function (o2) {
      return 'variant-picker label:has(input[value="' + CSS.escape(o2) + '"])';
    }).join(',') + '{display:none !important;}';
  }

  // ---- 品切れ表示（マトリクスの avail 由来） -------------------------------
  // 方針：
  //   「存在しない組み合わせ」＝ updateHideCSS で display:none（従来どおり）
  //   「実在するが在庫切れ」   ＝ ここでグレー＋斜線＋ピルを出す
  //   Fabric の data-option-available は切替直後に古い値のまま残るため信用せず、
  //   商品JSONから作ったマトリクスだけを根拠にする。
  //   ラベルはFabric再描画でクラスが飛ぶので、値ベースの :has() セレクタで指定する。

  function labelSels(vals) {
    return vals.map(function (v) { return 'variant-picker label:has(input[value="' + CSS.escape(v) + '"])'; });
  }
  function recordsOf(o1) {
    var out = [];
    O2_ALL.forEach(function (o2) { var r = MX[key(o1, o2)]; if (r) out.push(r); });
    return out;
  }

  // 品切れマークを付ける値の一覧
  //   種類軸: その種類の実在する組み合わせが全部在庫切れ
  //   金額軸: 選択中の種類で実在し、かつ在庫切れ
  // ※ 種類と金額で同一文字列の値が存在する商品では値ベース指定が交差する（本構成では未発生）
  function computeSoldoutVals(o1) {
    var vals = [];
    O1_ALL.forEach(function (v) {
      var recs = recordsOf(v);
      if (recs.length && recs.every(function (r) { return !r.avail; })) vals.push(v);
    });
    O2_ALL.forEach(function (o2) {
      var rec = MX[key(o1, o2)];
      if (rec && !rec.avail) vals.push(o2);
    });
    return vals;
  }

  // 既存 initVariantSoldoutDisplay を無効化する（判定根拠がDOMの斜線表示状態で、
  // この構成では「存在しない組み合わせ」まで品切れ扱いになるため）。
  //   ・品切れピルは id 指定 + !important で打ち消す
  //   ・動的CSSは同じidの<style>を先に作って media="not all" で無効化しておく
  //     （legacy側は getElementById で既存要素を再利用し textContent だけ書き換えるため、
  //      media 属性は残り続ける）
  function suppressLegacy() {
    if (document.getElementById(NEUTRALIZE_STYLE_ID)) return;
    styleEl(NEUTRALIZE_STYLE_ID).textContent =
      '#a97-variant-soldout-label{display:none !important;}';
    var d = document.getElementById('a97-variant-soldout-dynamic');
    if (!d) {
      d = document.createElement('style');
      d.id = 'a97-variant-soldout-dynamic';
      document.head.appendChild(d);
    }
    d.setAttribute('media', 'not all');
  }

  // Fabric の斜線はCSSではなくマークアップ駆動で、在庫切れラベルにだけ
  // <svg class="variant-option__strikethrough"> をサーバーサイドで出力する。
  // 切替直後は要素自体が存在しないため（＝セクション差し替えまで斜線が出ない）、
  // 同じ構造をこちらで生成する。位置・寸法・線色はテーマCSSがクラスで当てる。
  var SVG_NS = 'http://www.w3.org/2000/svg';
  function ensureStrikethrough(label) {
    if (label.querySelector('.variant-option__strikethrough')) return false;
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 100 46');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    svg.setAttribute('class', 'variant-option__strikethrough');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('data-a97-injected', '');
    for (var i = 0; i < 2; i++) {   // Fabric純正も line を2本重ねている
      var ln = document.createElementNS(SVG_NS, 'line');
      ln.setAttribute('x1', '100'); ln.setAttribute('y1', '0');
      ln.setAttribute('x2', '0');   ln.setAttribute('y2', '46');
      ln.setAttribute('vector-effect', 'non-scaling-stroke');
      svg.appendChild(ln);
    }
    label.appendChild(svg);
    return true;
  }
  function dropStrikethrough(label) {
    var svg = label.querySelector('.variant-option__strikethrough');
    if (!svg) return false;
    svg.remove();
    return true;
  }

  // data-option-available をマトリクスの値で即時に正す。
  // Fabric はこの属性を切替後2〜3秒間ふるい値のまま残し、テーマCSSは
  //   ・:has([data-option-available="false"]) → border-width:0（選択リングが消える）
  //   ・:has([data-option-available="false"]) → 文字色をopacity 60%のグレーへ
  // をこの属性だけで判定しているため、選択強調と品切れグレーが遅延する。
  // 属性はテーマJS（variant-picker.js）からは参照されておらず、表示専用。
  function syncAvailAttrs(o1, soldoutSet) {
    var fs = fieldsets();
    var changed = false;
    function apply(inp, avail) {
      var v = avail ? 'true' : 'false';
      if (inp.getAttribute('data-option-available') !== v) { inp.setAttribute('data-option-available', v); changed = true; }
      if (avail) { if (inp.hasAttribute('aria-disabled')) { inp.removeAttribute('aria-disabled'); changed = true; } }
      else if (inp.getAttribute('aria-disabled') !== 'true') { inp.setAttribute('aria-disabled', 'true'); changed = true; }
      var lbl = inp.closest('label');
      if (!lbl) return;
      if (avail) { if (dropStrikethrough(lbl)) changed = true; }
      else if (ensureStrikethrough(lbl)) changed = true;
    }
    if (fs[0]) fs[0].querySelectorAll('input[type="radio"]').forEach(function (inp) {
      if (O1_ALL.indexOf(inp.value) < 0) return;
      apply(inp, !soldoutSet[inp.value]);
    });
    if (fs[1]) fs[1].querySelectorAll('input[type="radio"]').forEach(function (inp) {
      var rec = MX[key(o1, inp.value)];
      if (!rec) return;              // 存在しない組み合わせは updateHideCSS で非表示
      apply(inp, !!rec.avail);
    });
    return changed;
  }

  // Chrome は :has() ベースのスタイルを「JSで checked を書き換えた場合」に再計算しない。
  // 実測（001780）：inp.checked への代入・checked属性の同期・スタイルシート追記・
  // クラストグルのいずれでも選択枠線の色が更新されず、fieldset を一瞬 display:none に
  // すると正しい状態（旧=薄い / 新=濃い）に確定した。テーマの選択強調は
  // label の border-color（--color-selected-variant-border）なので、
  // これが更新されないと自動選択された金額に強調が出ない（＝セクション差し替えまで3秒待ち）。
  // 同一タスク内で元に戻すため描画フレームには出ない。
  function forceRestyle(el) {
    if (!el) return;
    var prev = el.style.display;
    el.style.display = 'none';
    void el.offsetHeight;
    el.style.display = prev;
  }

  // スウォッチ表示のバリアント用（テキストボタンはFabric純正の斜線＋グレーで足りる）。
  // 斜線SVGは色丸の上で見えにくいので、legacy と同じく色丸へ斜線を描く。
  function updateSoldoutCSS(vals) {
    var s = styleEl(SOLDOUT_STYLE_ID);
    if (!vals.length) { s.textContent = ''; return; }
    var sels = labelSels(vals);
    function j(suffix) { return sels.map(function (x) { return x + suffix; }).join(','); }
    s.textContent =
      j(':has(.swatch) .swatch') + '{opacity:.35 !important;position:relative;overflow:hidden;}' +
      j(':has(.swatch) .swatch::after') +
        '{content:"";position:absolute;top:0;left:0;width:100%;height:100%;' +
        'background:linear-gradient(to top right,transparent 43%,#888 43%,#888 57%,transparent 57%);' +
        'pointer-events:none;border-radius:inherit;}' +
      j(':has(.swatch) .variant-option__strikethrough') + '{display:none !important;}';
  }

  function injectPillBase() {
    if (document.getElementById(SOLDOUT_BASE_ID)) return;
    styleEl(SOLDOUT_BASE_ID).textContent =
      '#' + PILL_ID + '{display:block;background:#fff0f0;color:#d63a3a;font-size:11px;' +
      'font-weight:600;padding:3px 14px;border-radius:4px;border:1px solid #f0c8c8;' +
      'text-align:center;width:fit-content;}' +
      // ピルが入った行は align-items:center（選択リングの楕円化防止＋縦中央揃え）
      'variant-picker fieldset:has(#' + PILL_ID + '){align-items:center;}';
  }

  // 選択中の組み合わせが在庫切れなら金額行の末尾にピルを出す
  function updatePill(o1, o2) {
    var pill = document.getElementById(PILL_ID);
    var rec = (o1 && o2) ? MX[key(o1, o2)] : null;
    if (!rec || rec.avail) { if (pill) pill.style.display = 'none'; return; }

    var fsAmt = fieldsets()[1];
    var inp = fsAmt && fsAmt.querySelector('input[type="radio"]:checked');
    var lbl = inp ? inp.closest('label') : null;
    if (!lbl || !lbl.parentElement) { if (pill) pill.style.display = 'none'; return; }

    if (!pill) {
      pill = document.createElement('div');
      pill.id = PILL_ID;
      pill.textContent = '一時品切中';
    }
    if (pill.parentElement !== lbl.parentElement) lbl.parentElement.appendChild(pill);
    pill.style.display = '';
  }

  // ---- カートボタンの即時同期 ---------------------------------------------
  // Fabricはセクション差し替えが終わるまでボタンを更新しないため、
  // input[name="id"] は既に品切れバリアントを指しているのに
  // 「カートに追加する」が押せる状態が数百ms〜数秒続く（実測: 60msの時点で押下可能）。
  // マトリクスの avail でボタンの disabled とラベルを即時に合わせる。
  var ATC_LABEL = { avail: null, soldout: null };
  var ATC_FALLBACK = { avail: 'カートに追加する', soldout: '一時品切中' };

  function atcButton() {
    var f = document.querySelector('form[action*="/cart/add"]');
    if (!f) return null;
    return f.querySelector('button[name="add"]') || f.querySelector('button[type="submit"]');
  }
  // ラベルは .add-to-cart-text__content > span > span の最内側テキスト
  function atcTextEl(btn) {
    var c = btn.querySelector('.add-to-cart-text__content');
    if (!c) return null;
    while (c.firstElementChild) c = c.firstElementChild;
    return c;
  }

  function syncAtc(o1, o2) {
    var rec = (o1 && o2) ? MX[key(o1, o2)] : null;
    if (!rec) return;
    var btn = atcButton();
    if (!btn) return;
    var el = atcTextEl(btn);
    var cur = el ? el.textContent.trim() : '';
    var wantDisabled = !rec.avail;
    // ボタンの状態とマトリクスが一致している間のラベルはサーバー由来＝正なので記憶し、
    // 以降の書き換えに使う（テーマの文言変更に追従するため）。
    if (cur && btn.disabled === wantDisabled) ATC_LABEL[rec.avail ? 'avail' : 'soldout'] = cur;
    var want = rec.avail ? (ATC_LABEL.avail || ATC_FALLBACK.avail)
                         : (ATC_LABEL.soldout || ATC_FALLBACK.soldout);
    if (btn.disabled !== wantDisabled) btn.disabled = wantDisabled;
    if (el && cur !== want) el.textContent = want;
  }

  // 品切れ表示一式の再計算（種類切替・金額切替・Fabric再描画後に呼ぶ）
  // 属性書き換え → CSS → ピルの順。属性が正しくなった時点でFabric純正の
  // グレー・斜線・選択リングが即時に正しく出るので、CSSでの上書きは
  // スウォッチ用の斜線のみ。
  function syncSoldout(o1, o2) {
    if (syncing || !MX) return;
    syncing = true;
    try {
      var fs = fieldsets();
      if (o1 == null) o1 = checkedValue(fs[0]);
      if (o2 == null) o2 = checkedValue(fs[1]);
      if (!o1) return;
      var vals = computeSoldoutVals(o1);
      var set = {};
      vals.forEach(function (v) { set[v] = 1; });
      var changed = syncAvailAttrs(o1, set);
      updateSoldoutCSS(vals);
      updatePill(o1, o2);
      syncAtc(o1, o2);
      if (changed) { forceRestyle(fs[0]); forceRestyle(fs[1]); }
    } finally {
      syncing = false;
    }
  }

  // theme.liquid 側クロークを解除（正しい状態を適用後に表示）
  function revealCloak() {
    var c = document.getElementById(CLOAK_ID);
    if (c) c.remove();
  }

  // o1 に対する金額を解決（在庫有りを優先、無ければ存在する先頭。いずれもDOM順）
  function resolveAmount(o1, preferred) {
    if (preferred && MX[key(o1, preferred)]) return preferred;
    var fsAmt = fieldsets()[1];
    if (!fsAmt) return null;
    var inps = fsAmt.querySelectorAll('input[type="radio"]');
    var firstExisting = null;
    for (var i = 0; i < inps.length; i++) {
      var o2 = inps[i].value;
      var rec = MX[key(o1, o2)];
      if (!rec) continue;
      if (firstExisting === null) firstExisting = o2;
      if (rec.avail) return o2;
    }
    return firstExisting;
  }

  // 商品コード/SKU表示の更新（Fabricはバリアント変更でこのブロックを更新しないため自前で反映）
  function setBarcode(rec) {
    document.querySelectorAll('.product-barcode').forEach(function (block) {
      var lbl = block.querySelector('.product-barcode__label');
      var val = block.querySelector('.product-barcode__value');
      if (!val) return;
      var isSku = lbl && /SKU/i.test(lbl.textContent);
      var text = isSku ? (rec.sku || '') : (rec.barcode || rec.sku || '');
      if (text) val.textContent = text;
    });
  }

  // 楽観的更新: 価格表示・カートid・商品コードを即時に正しい値へ（Fabricは数秒後に同値で確定）
  function applyOptimistic(o1, o2) {
    var rec = MX[key(o1, o2)];
    if (!rec) return;
    setCartId(rec.id);
    setPrice(rec.price);
    setBarcode(rec);
  }

  function onTypeChange(o1) {
    if (busy) return;
    updateHideCSS(o1);
    var fsAmt = fieldsets()[1];
    if (!fsAmt) return;
    var cur = checkedValue(fsAmt);
    var target = resolveAmount(o1, cur);
    if (!target) return;
    if (target !== cur) {
      var inp = Array.from(fsAmt.querySelectorAll('input[type="radio"]')).find(function (i) { return i.value === target; });
      if (inp) {
        busy = true;
        inp.checked = true;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
        busy = false;
        forceRestyle(fsAmt);   // :has(:checked) の再計算をChromeに強制する

      }
    }
    applyOptimistic(o1, target);
    syncSoldout(o1, target);
  }

  function onAmountChange(o2) {
    var fs = fieldsets();
    if (!fs[0]) return;
    var o1 = checkedValue(fs[0]);
    applyOptimistic(o1, o2);
    syncSoldout(o1, o2);
  }

  function bind() {
    var fs = fieldsets();
    if (fs.length < 2) { revealCloak(); return false; }
    var fsType = fs[0], fsAmt = fs[1];
    if (fsType._a97dvf) return true;
    fsType._a97dvf = true;
    fsAmt._a97dvf = true;

    suppressLegacy();
    injectPillBase();

    fsType.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') onTypeChange(e.target.value);
    });
    fsAmt.addEventListener('change', function (e) {
      if (busy) return;
      if (e.target && e.target.type === 'radio') onAmountChange(e.target.value);
    });

    onTypeChange(checkedValue(fsType));
    revealCloak();

    document.addEventListener('variant:update', function () {
      var t = checkedValue(fieldsets()[0]);
      if (t) updateHideCSS(t);
      syncSoldout();
    });

    // Fabric がセクションHTMLを差し替えるとピルのDOMが消えるため再挿入する
    var v = vp();
    if (v && !v._a97dvfObs) {
      v._a97dvfObs = true;
      // Fabric がセクションHTMLを差し替えると属性・斜線SVG・ピルが元に戻るため、
      // 差し替え後にもう一度当てる。属性を戻された場合も拾えるよう attributes も監視。
      // 書き込みは値が違うときだけなので、監視 → 再適用のループにはならない。
      new MutationObserver(function () {
        clearTimeout(v._a97dvfTimer);
        v._a97dvfTimer = setTimeout(function () { syncSoldout(); }, 80);
      }).observe(v, {
        childList: true, subtree: true,
        attributes: true, attributeFilter: ['data-option-available', 'data-current-checked']
      });
    }
    return true;
  }

  function start() {
    var handle = getHandle();
    if (!handle) { revealCloak(); return; }
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j.options || j.options.length !== 2) { revealCloak(); return; }   // 2軸（種類×金額）構成のみ対象
        MX = {};
        O1_ALL = [];
        O2_ALL = [];
        var o1set = {}, o2set = {};
        j.variants.forEach(function (v) {
          MX[key(v.option1, v.option2)] = { id: v.id, price: v.price / 100, avail: v.available, sku: v.sku, barcode: v.barcode };
          o1set[v.option1] = 1; o2set[v.option2] = 1;
          if (O1_ALL.indexOf(v.option1) < 0) O1_ALL.push(v.option1);
          if (O2_ALL.indexOf(v.option2) < 0) O2_ALL.push(v.option2);
        });
        // 全組み合わせが揃う通常商品（従属関係なし）は対象外
        if (j.variants.length >= Object.keys(o1set).length * Object.keys(o2set).length) { revealCloak(); return; }
        window.__a97DepFixActive = true;
        if (!bind()) {
          var obs = new MutationObserver(function () { if (bind()) obs.disconnect(); });
          obs.observe(document.body, { childList: true, subtree: true });
        }
      })
      .catch(function () { revealCloak(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
// GPOレンジスライダー: ツールチップ・min/maxの金額整形（カンマ＋円）
(function initGpoRangeFormat() {
  if (!window.location.pathname.startsWith('/products/')) return;

  function fmt(s) {
    var t = (s || '').trim();
    if (!/^\d+$/.test(t)) return null;
    return Number(t).toLocaleString('ja-JP') + '円';
  }

  function applyTo(range) {
    if (range.dataset.rangeFmt) return;
    range.dataset.rangeFmt = '1';

    ['.gpo-range-min', '.gpo-range-max'].forEach(function (sel) {
      var el = range.querySelector(sel);
      var v = el && fmt(el.textContent);
      if (v) el.textContent = v;
    });

    var tt = range.querySelector('.gpo-range-tooltip');
    if (!tt) return;
    var reformat = function () {
      var v = fmt(tt.textContent);
      if (v) tt.textContent = v; // 整形済みは/^\d+$/に落ちるため無限ループしない
    };
    reformat();
    new MutationObserver(reformat).observe(tt, { childList: true, characterData: true, subtree: true });
  }

  function scan() {
    document.querySelectorAll('.gpo-range').forEach(applyTo);
  }

  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();

// 単一オプション（色ごとに価格が異なる）商品の楽観的価格更新
// DVF（2オプション用 applyOptimistic）は options.length!==2 で対象外のため、
// 価格差のある単一オプション商品は Fabric の section 再取得
// （切替ごとの GET /products/xxx?option_values=…）の戻りまで価格・cartId・
// ポイントが数秒据え置かれる。Globo Pre-Order の preorderjson 多発と
// 同一ホスト同時接続数上限が重なり、ロード直後は特に遅延が伸びる。
// ここでは商品JSON由来の値で表示を即時確定し、Fabricは後追いで同値に上書きさせる。
(function () {
  if (!window.location.pathname.startsWith('/products/')) return;

  function getHandle() {
    var m = window.location.pathname.match(/\/products\/([^?#/]+)/);
    return m ? m[1] : null;
  }
  function fmtYen(y) { return String(y).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' 円'; }

  function priceSpan() {
    var c = document.querySelector('.text-block [ref="priceContainer"]');
    if (!c) return null;
    return c.querySelector('.price__regular:not(.price__hidden) span.price') ||
           c.querySelector('.price__sale:not(.price__hidden) span.price-item--sale') ||
           c.querySelector('span.price');
  }
  function setPrice(yen) {
    var el = priceSpan();
    if (el && el.textContent !== fmtYen(yen)) el.textContent = fmtYen(yen);
  }
  function setCartId(id) {
    document.querySelectorAll('input[name="id"]').forEach(function (i) {
      if (i.value !== String(id)) i.value = String(id);
    });
  }
  function setBarcode(rec) {
    document.querySelectorAll('.product-barcode').forEach(function (block) {
      var lbl = block.querySelector('.product-barcode__label');
      var val = block.querySelector('.product-barcode__value');
      if (!val) return;
      var isSku = lbl && /SKU/i.test(lbl.textContent);
      var text = isSku ? (rec.sku || '') : (rec.barcode || rec.sku || '');
      if (text && val.textContent !== text) val.textContent = text;
    });
  }

  var MAP = null;       // option1値 → {id, price, sku, barcode}
  var pending = null;   // 現在選択中のレコード（キーパーが再アサートに使う）

  function applyNow(rec) { setCartId(rec.id); setPrice(rec.price); setBarcode(rec); }

  function bind() {
    // documentにcapture束縛。variant-picker/fieldsetがFabric差し替えで消えても
    // 束縛は生き残り、Fabric本体のchangeハンドラより先に価格を確定させる。
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.closest || !e.target.closest('variant-picker')) return;
      var rec = MAP[e.target.value];   // 数量入力等は MAP に無いので無視される
      if (!rec) return;
      pending = rec;
      applyNow(rec);
    }, true);

    // Fabricの遅延fetchが古い価格でコンテナを差し替えても正しい値へ戻す。
    // 書き込みは値が違うときだけなので監視→再適用のループにはならない。
    var host = document.querySelector('.product-information') ||
               document.querySelector('.text-block') || document.body;
    new MutationObserver(function () { if (pending) applyNow(pending); })
      .observe(host, { childList: true, subtree: true, characterData: true });
  }

  function start() {
    var handle = getHandle();
    if (!handle) return;
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j.options || j.options.length !== 1) return;   // 単一オプションのみ対象
        var prices = {};
        j.variants.forEach(function (v) { prices[v.price] = 1; });
        if (Object.keys(prices).length < 2) return;         // 価格が一律なら効果なし＝対象外
        MAP = {};
        j.variants.forEach(function (v) {
          MAP[v.option1] = { id: v.id, price: v.price / 100, sku: v.sku, barcode: v.barcode };
        });
        window.__a97SinglePriceFixActive = true;
        bind();
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

// 商品ギャラリー（カルーセル）：見えているスライド以外の画像読み込みを保留する
// カルーセルのレイアウトはそのまま、全スライド即時ダウンロードだけを回避する。
//
// 仕組み（常時ポーリング廃止版）：
//   ・位置判定 sync()：<slideshow-slides> 配下の各スライドについて、画面上の位置
//     （getBoundingClientRect）が表示範囲＋前後バッファの外なら、まだ読み込み中の画像だけ
//     src/srcset を退避して外し、ダウンロードを打ち切る。読み込み済みはそのまま（無駄な再取得なし）。
//     同期処理なので背景タブや transform カルーセルでも確実に効く。
//   ・IntersectionObserver：前景での見え方の変化を、レイアウト強制なしで拾う（効率重視の主役）。
//     背景タブでは配信されないが、その間は見えていないので問題ない（前景復帰時に下記で復帰）。
//   ・操作イベント（矢印・サムネイル・スワイプ・キー）と variant:update、resize、
//     visibilitychange のときだけ sync() を呼ぶ。以前の 400ms 常時ポーリングは廃止。
//   ・読み込み直後のレイアウト確定を数回だけ拾う（これも常時ではない）。
(function initGalleryLazyDefer() {
  'use strict';
  if (!window.location.pathname.startsWith('/products/')) return;

  var BUFFER_PX = 500; // 表示範囲の前後、この距離内のスライドは読み込んでおく

  function slidesOf(track) {
    return Array.from(track.children).filter(function (el) {
      return el.tagName === 'SLIDESHOW-SLIDE';
    });
  }

  function deferImage(img) {
    // 一度読み込みを止めた／既に読み込み済みの画像は、以降さわらない（再ダウンロードを避ける）
    if (img.dataset.a97GalleryLazy) return;
    img.dataset.a97GalleryLazy = '1';
    if (img.complete) return; // 既に転送済みなら止めない
    var src = img.getAttribute('src');
    var srcset = img.getAttribute('srcset');
    if (src) img.dataset.a97Src = src;
    if (srcset) img.dataset.a97Srcset = srcset;
    img.removeAttribute('src');
    img.removeAttribute('srcset');
  }

  function restoreImage(img) {
    if (img.dataset.a97Src) {
      img.setAttribute('src', img.dataset.a97Src);
      delete img.dataset.a97Src;
    }
    if (img.dataset.a97Srcset) {
      img.setAttribute('srcset', img.dataset.a97Srcset);
      delete img.dataset.a97Srcset;
    }
  }

  // 位置ベースの一括判定（同期／背景タブでも動く保険）
  function sync(track) {
    var slides = slidesOf(track);
    if (slides.length <= 1) return;
    var tr = track.getBoundingClientRect();
    slides.forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img) return;
      var r = slide.getBoundingClientRect();
      var near = r.right > (tr.left - BUFFER_PX) && r.left < (tr.right + BUFFER_PX);
      if (near) restoreImage(img); else deferImage(img);
    });
  }

  function bind(track) {
    if (track._a97GalleryBound) return;
    track._a97GalleryBound = true;

    // 1) 初期の間引き
    sync(track);

    // 2) IntersectionObserver（前景での効率的な検知。レイアウト強制なし）
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var img = e.target.querySelector('img');
          if (!img) return;
          if (e.isIntersecting) restoreImage(img); else deferImage(img);
        });
      }, {
        root: track,
        rootMargin: '0px ' + BUFFER_PX + 'px 0px ' + BUFFER_PX + 'px',
        threshold: 0
      });
      slidesOf(track).forEach(function (s) { io.observe(s); });
      track._a97GalleryIO = io;
    }

    // 3) ユーザー操作時のみ再判定（常時ポーリングの置き換え）。
    //    操作直後の描画確定を拾うため、その時だけ数回。
    function kick() {
      sync(track);
      setTimeout(function () { sync(track); }, 200);
      setTimeout(function () { sync(track); }, 500);
    }
    var host = track.closest('slideshow-component') || track;
    host.addEventListener('click', kick, true);
    host.addEventListener('pointerup', kick, true);
    host.addEventListener('touchend', kick, { passive: true, capture: true });
    host.addEventListener('keyup', kick, true);

    // 4) バリアント変更でメイン画像が差し替わるケース
    document.addEventListener('variant:update', kick);

    // 5) リサイズ（段組み・ピーク幅の変化）
    window.addEventListener('resize', function () {
      clearTimeout(track._a97GalleryRz);
      track._a97GalleryRz = setTimeout(function () { sync(track); }, 150);
    });

    // 6) 背景→前景復帰（背景中は IO が止まるので一度だけ手動で合わせる）
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) sync(track);
    });

    // 7) 読み込み直後のレイアウト確定を数回だけ拾う（常時ポーリングではない）
    setTimeout(function () { sync(track); }, 300);
    setTimeout(function () { sync(track); }, 1200);
  }

  function init() {
    var track = document.querySelector('slideshow-slides');
    if (track) { bind(track); return; }
    var obs = new MutationObserver(function () {
      var t = document.querySelector('slideshow-slides');
      if (t) { bind(t); obs.disconnect(); }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// GPO連動商品: 商品ページへのリンク
(function initGpoAddonLinks() {
  if (!window.location.pathname.startsWith('/products/')) return;

  var STYLE_ID     = 'a97-gpo-plink-style';
  var CACHE_PREFIX = 'a97gpl:';
  var CACHE_TTL    = 86400000;
  var ADDON_TAG    = 'globo-product-options';
  var LABEL        = '商品ページ';
  var INPUT_SEL    = '.gpo-app input[gpo-data-variant-id]';

  var resolved = {};
  var inflight = {};
  var queue    = [];
  var running  = false;
  var ready    = false;
  var io       = null;
  var watched  = new WeakSet();

  function injectCSS() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '.gpo-app .a97-gpo-plink{display:inline-flex !important;align-items:center;gap:3px;' +
        'flex:0 0 auto;margin-left:6px;padding:0 6px 0 8px;' +
        'border:1px solid #dcdcd8;border-radius:999px;background:#fff;color:#666 !important;' +
        'font-size:11px;line-height:20px;text-decoration:none !important;white-space:nowrap;' +
        'pointer-events:auto;vertical-align:middle;}' +
      '.gpo-app .a97-gpo-plink svg{width:8px;height:8px;flex:0 0 auto;}' +
      '.gpo-app .a97-gpo-plink:hover{color:#111 !important;border-color:#b8b8b2;background:#f7f7f5;}' +
      '.gpo-app .a97-gpo-plink--qty{position:absolute;margin-left:0;cursor:pointer;z-index:1;}' +
      '.gpo-app .a97-gpo-plink-dd{margin-top:6px;}' +
      '.gpo-app .a97-gpo-plink-dd .a97-gpo-plink{margin-left:0;}';
    document.head.appendChild(s);
  }

  function cacheGet(vid) {
    try {
      var raw = localStorage.getItem(CACHE_PREFIX + vid);
      if (!raw) return undefined;
      var o = JSON.parse(raw);
      if (Date.now() - o.t > CACHE_TTL) return undefined;
      return o.u;
    } catch (e) { return undefined; }
  }
  function cacheSet(vid, url) {
    try { localStorage.setItem(CACHE_PREFIX + vid, JSON.stringify({ u: url, t: Date.now() })); } catch (e) {}
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  // undefined: この商品にvidが無い / null: アドオン商品 / 文字列: リンク先
  function urlFrom(j, vid) {
    if (!j || !j.variants) return undefined;
    var has = j.variants.some(function (v) { return String(v.id) === vid; });
    if (!has) return undefined;
    if ((j.tags || []).indexOf(ADDON_TAG) >= 0) return null;
    return '/products/' + j.handle + '?variant=' + vid;
  }

  // GPO属性のハンドルは古い場合がある（例: option-set-1425522-checkbox-3 → 765425）
  function lookup(vid, handle) {
    return fetchProduct(handle).then(function (j) {
      var u = urlFrom(j, vid);
      if (u !== undefined) return u;
      return fetch('/variants/' + vid, { method: 'HEAD', credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) return null;
        var m = new URL(r.url).pathname.match(/\/products\/([^/?#]+)/);
        if (!m) return null;
        var h2 = decodeURIComponent(m[1]);
        if (h2 === handle) return null;
        return fetchProduct(h2).then(function (j2) {
          var u2 = urlFrom(j2, vid);
          return u2 === undefined ? null : u2;
        });
      });
    });
  }

  function enqueue(vid, handle) {
    if (!vid || !handle) return;
    if (resolved.hasOwnProperty(vid) || inflight[vid]) return;
    var c = cacheGet(vid);
    if (c !== undefined) { resolved[vid] = c; return; }
    inflight[vid] = true;
    queue.push([vid, handle]);
    pump();
  }

  // 1本ずつ直列（Fabricのsection再取得・Pre-Orderと同時接続を取り合わないため）
  function pump() {
    if (running || !queue.length) return;
    running = true;
    var job = queue.shift();
    lookup(job[0], job[1]).then(function (u) {
      resolved[job[0]] = u;
      cacheSet(job[0], u);
    }, function () {
      resolved[job[0]] = null;
    }).then(function () {
      delete inflight[job[0]];
      running = false;
      render();
      pump();
    });
  }

  function buildLink(url, name) {
    var a = document.createElement('a');
    a.className = 'a97-gpo-plink';
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('aria-label', name + ' の' + LABEL + 'を新しいタブで開く');
    a.textContent = LABEL;
    a.insertAdjacentHTML('beforeend',
      '<svg viewBox="0 0 8 8" fill="none" stroke="currentColor" stroke-width="1.4" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      '<path d="M2.5 1 5.5 4 2.5 7"/></svg>');
    a.addEventListener('click', function (e) { e.stopPropagation(); });
    return a;
  }

  function renderDropdown(el) {
    var dd = el.querySelector('.gpo-dropdown');
    if (!dd) return;
    var checked = dd.querySelector('input[data-type="dropdown"]:checked');
    var vid = checked ? checked.getAttribute('gpo-data-variant-id') : null;
    var url = vid ? resolved[vid] : null;
    var box = el.querySelector('.a97-gpo-plink-dd');
    if (!url) { if (box) box.remove(); return; }
    if (box && box.dataset.vid === vid) return;
    if (box) box.remove();
    box = document.createElement('div');
    box.className = 'a97-gpo-plink-dd';
    box.dataset.vid = vid;
    box.appendChild(buildLink(url, checked.value));
    dd.insertAdjacentElement('afterend', box);
  }

  // カウンターの子にすると GPO の `.gpo-ov-quantity > *`（pointer-events/cursor）と opacity を受けるため兄弟に置く
  function placeBesideQty(a, qty) {
    var s = getComputedStyle(qty);
    a.style.left = (qty.offsetLeft || parseFloat(s.marginLeft) || 0) +
                   (qty.offsetWidth || parseFloat(s.width) || 0) + 10 + 'px';
    if (qty.offsetParent) {
      a.style.top = (qty.offsetTop + qty.offsetHeight / 2) + 'px';
      a.style.bottom = '';
      a.style.transform = 'translateY(-50%)';
    } else {
      a.style.top = '';
      a.style.bottom = ((parseFloat(s.height) || 26) / 2) + 'px';
      a.style.transform = 'translateY(50%)';
    }
  }

  // 数量カウンターがあればその右（absolute、高さを変えない）。無ければ label の直後（label内だとチェックが切り替わる）
  function render() {
    document.querySelectorAll(INPUT_SEL).forEach(function (inp) {
      if (inp.getAttribute('data-type') === 'dropdown') return;
      var url = resolved[inp.getAttribute('gpo-data-variant-id')];
      if (!url) return;
      var item = inp.closest('.gpo-ov-item');
      if (!item) return;
      var qty = item.querySelector('.gpo-ov-quantity');
      var cur = item.querySelector('.a97-gpo-plink');
      if (cur) {
        if (qty && cur.classList.contains('a97-gpo-plink--qty')) placeBesideQty(cur, qty);
        return;
      }
      if (qty) {
        var a = buildLink(url, inp.value);
        a.classList.add('a97-gpo-plink--qty');
        qty.insertAdjacentElement('afterend', a);
        placeBesideQty(a, qty);
        return;
      }
      var lbl = (inp.id && item.querySelector('label[for="' + CSS.escape(inp.id) + '"]')) ||
                item.querySelector('label');
      if (!lbl) return;
      lbl.insertAdjacentElement('afterend', buildLink(url, inp.value));
    });
    document.querySelectorAll('.gpo-app .gpo-element').forEach(renderDropdown);
  }

  function onVisible(entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      e.target.querySelectorAll('input[gpo-data-variant-id]').forEach(function (inp) {
        enqueue(inp.getAttribute('gpo-data-variant-id'), inp.getAttribute('gpo-data-product-handle'));
      });
    });
    render();
  }

  function watch() {
    document.querySelectorAll('.gpo-app .gpo-element').forEach(function (el) {
      if (watched.has(el) || !el.querySelector('input[gpo-data-variant-id]')) return;
      watched.add(el);
      io.observe(el);
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      watch();
      render();
    });
  }

  function start() {
    if (ready) return;
    ready = true;
    if (!('IntersectionObserver' in window)) return;
    injectCSS();
    io = new IntersectionObserver(onVisible, { rootMargin: '300px 0px' });
    watch();
    render();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.getAttribute || t.getAttribute('data-type') !== 'dropdown') return;
      enqueue(t.getAttribute('gpo-data-variant-id'), t.getAttribute('gpo-data-product-handle'));
      render();
    }, true);
  }

  function whenIdle() {
    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 3000 });
    else setTimeout(start, 1500);
  }

  if (document.readyState === 'complete') whenIdle();
  else window.addEventListener('load', whenIdle);
})();